import { render, staticRenderFns } from "./comp_RatioImage.vue?vue&type=template&id=da39b98e&scoped=true&"
import script from "./comp_RatioImage.vue?vue&type=script&lang=js&"
export * from "./comp_RatioImage.vue?vue&type=script&lang=js&"
import style0 from "./comp_RatioImage.vue?vue&type=style&index=0&id=da39b98e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da39b98e",
  null
  
)

export default component.exports